import i18n from '@/utils/i18n';
import React from 'react';
import {
  Button,
  DatePickerCalendar,
  XStack,
  YStack,
} from '@usepepper/sprout-kit-ui';
import {
  DateTimeSelection,
  TIME_PICKER_MINUTE_STEPS,
} from '@/experiences/sales-portal/blocs/utils/date-picker-calendar-utils';
import { useDateTimePicker } from '@/experiences/sales-portal/blocs/hooks/use-date-time-picker';
import { useTheme } from '@/contexts/theme-context';

interface ActivityNoteReminderContentProps {
  onClose: () => void;
  onSetReminder: (reminder?: DateTimeSelection) => void;
  reminder?: DateTimeSelection;
}

export const ActivityNoteReminderContent: React.FC<
  ActivityNoteReminderContentProps
> = ({ onClose, onSetReminder, reminder }) => {
  const theme = useTheme();
  const {
    getValidSelection,
    handleDateChange,
    handleTimeChange,
    isSelectionValid,
    selectedDate,
    selectedTime,
  } = useDateTimePicker(reminder);

  const handleConfirm = () => {
    const selection = getValidSelection();

    if (!selection) {
      return;
    }

    onSetReminder(selection);
    onClose();
  };

  return (
    <YStack gap={theme.sk.spacing.spaceMedium}>
      <DatePickerCalendar
        ampm
        mode="single"
        onChange={handleDateChange}
        onTimeChange={handleTimeChange}
        time={selectedTime}
        timeLabel={i18n.t('sales_portal.activity_note.reminder.time_label')}
        timeSteps={{ minutes: TIME_PICKER_MINUTE_STEPS }}
        value={selectedDate ? [selectedDate] : []}
      />
      <XStack gap={theme.sk.spacing.spaceSmall} justifyContent="flex-end">
        <Button onPress={onClose} size="$sm" variant="secondary">
          {i18n.t('sales_portal.activity_note.reminder.cancel')}
        </Button>
        <Button
          accessibilityLabel={i18n.t(
            'sales_portal.activity_note.reminder.confirm',
          )}
          disabled={!isSelectionValid}
          onPress={handleConfirm}
          size="$sm"
          variant="primary"
        >
          {i18n.t('sales_portal.activity_note.reminder.confirm')}
        </Button>
      </XStack>
    </YStack>
  );
};
